import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import Slidegallery from '../../containers/slidegallery';
import SlidegalleryItem from '../../blocks/slidegallery-item';
//import PhotoInfo from '../../containers/photo-info';

const SlidegalleryBlock = props => <Slidegallery {...props} />;
SlidegalleryBlock.displayName = 'Slidegallery';

export default withDynamicComponents({
  componentWhitelist: [
    SlidegalleryItem,
    //PhotoInfo
  ],
  mapInputToOutput: [
    ['slidegalleryItem', 'slidegalleryItem'],
    //['photoInfo', 'photoInfo']
  ],
})(SlidegalleryBlock);



// WEBPACK FOOTER //
// ./src/blocks/slidegallery/index.jsx